import "./style.scss";

import { Col, Container } from "@amzn/stencil-react-components/layout";
import { LinkIconPosition } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import IconChevronRight from "@amzn/stencil-react-icons/icons/icon-chevron-right";
import { IconSize } from "@amzn/stencil-react-icons/icons/interfaces";
import { Link } from "@amzn/uxm-stencil-react-components/lib/src/stencil/link";
import SearchBoxFactory from "common/factories/search-box-factory";
import { AmazonianInformation } from "lib/models/oui-models";
import { UserInformation } from "lib/services/user-information-service";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { getString } from "../../uistringlabels/uiStringUtils";

export interface HeroProps {
  toggleSearchExperience?: boolean;
}

export const Hero = (props: HeroProps) => {
  const history = useHistory();
  const [userInfo, setUserInfo] = useState<AmazonianInformation | null>(null);
  const [isUserInfoLoaded, setIsUserInfoLoaded] = useState(false);

  useEffect(() => {
    UserInformation.current
      .getUserInformation()
      .then((info) => {
        setUserInfo(info);
      })
      .catch((error) => {
        console.error("Error fetching user information:", error);
      })
      .finally(() => {
        setIsUserInfoLoaded(true);
      });
  }, []);

  const goToBrowseAll = () => {
    history.push("/search?query=");
  };

  return (
    <Container className="hero hero-background" display="flex" height={"100%"} width={"100%"}>
      <Col gridGap={"14px"} alignItems="flex-start" justifyContent="center">
        <Text data-cy="hero-title" color="neutral90" fontSize="T400" fontWeight="bold">
          {isUserInfoLoaded &&
            (userInfo?.basicInfo?.firstName
              ? getString("hero.titleWithName", { amazonianName: userInfo?.basicInfo.firstName })
              : getString("hero.titleWithoutName"))}
        </Text>
        <SearchBoxFactory
          width="600px"
          toggleSearchExperience={props.toggleSearchExperience}
          touchpointId="search-box-hero"
        />
        <Text>
          {getString("hero.notSure")}
          <Link
            onClick={goToBrowseAll}
            style={{ marginTop: "12px" }}
            fontSize="T200"
            color="neutral90"
            iconPosition={LinkIconPosition.Trailing}
            icon={<IconChevronRight color="neutral90" size={IconSize.Small} />}
            data-cy="browse-all-link"
            touchpoint="browse-all-link"
          >
            {getString("hero.browseAll")}
          </Link>
        </Text>
      </Col>
    </Container>
  );
};
